interface Props {
  label: string;
  value: string | number;
  sub: string;
  colorClass: string;
}
export function MetricCard({
  label,
  value,
  sub,
  colorClass
}: Props) {
  return <div className="mc" data-id="element-396">
      <div className="ml" data-id="element-397">{label}</div>
      <div className={`mv ${colorClass}`} data-id="element-398">{value}</div>
      <div className="ms" data-id="element-399">{sub}</div>
    </div>;
}